import { render, staticRenderFns } from "./clipper-fixed.vue?vue&type=template&id=264851ec&scoped=true"
import script from "./clipper-fixed.vue?vue&type=script&lang=js"
export * from "./clipper-fixed.vue?vue&type=script&lang=js"
import style0 from "./clipper-fixed.vue?vue&type=style&index=0&id=264851ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264851ec",
  null
  
)

export default component.exports